<script setup lang="ts">
import { localeLink } from '@/utils/template';

// Tabs Perfil | Dados | Notificações do Minha Conta V2 — SÓ no mobile
// (no desktop essas seções viram itens da sidebar "Edite seus dados").
interface Props {
  active: 'profile' | 'data' | 'notifications';
  // paridade com o menu antigo: esconde a tab Notificações quando o Smartico
  // não está ativo ou o usuário só pode sacar
  notificationsVisible?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  notificationsVisible: true,
});

const ALL_TABS = [
  { key: 'profile', label: 'Perfil', to: '/user/profile' },
  { key: 'data', label: 'Dados', to: '/user/data' },
  { key: 'notifications', label: 'Notificações', to: '/user/notifications' },
] as const;

const tabs = computed(() =>
  ALL_TABS.filter(
    (tab) => tab.key !== 'notifications' || props.notificationsVisible,
  ),
);
</script>

<template>
  <nav class="flex h-[36px] w-full items-center gap-[6px]">
    <NuxtLink
      v-for="tab in tabs"
      :key="tab.key"
      class="flex h-full flex-1 items-center justify-center rounded-[12px] text-[15px] leading-[20px]"
      :class="
        props.active === tab.key
          ? 'border border-solid border-v2-primary bg-gradient-to-r from-v2-primary/70 to-v2-primary/20 text-v2-primary-foreground'
          : 'bg-v2-default text-v2-default-foreground'
      "
      :to="localeLink(tab.to)"
    >
      {{ tab.label }}
    </NuxtLink>
  </nav>
</template>
